import React from "react";
import { Link } from "react-router-dom";
import classes from "./ButtonComp.module.css";

export default function ButtonComp({ link, customStyleClass, text }) {
  const buttonClass = customStyleClass
    ? customStyleClass
    : classes.customButton;

  return (
    <Link to={link} className={buttonClass}>
      {text}
    </Link>
  );
}
